var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sliders'),_c('WhoWeAre'),_c('Why2PayMe'),_c('Background'),_c('OurServices'),_c('WorkFields'),_c('Clients'),_c('FAQs'),_c('Testimonials'),_c('Download')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }